<template>
  <div>
    <div class="simple-scrubber" v-on:mousedown="mouseDown">
      <div class="simple-scrubber__line"></div>
      <div class="simple-scrubber__thingy" :style="{ left: scrubberPos }"></div>
    </div>
    <div class="scene-selector" v-if="localSections.length > 0">
      <div
        :ref="`section${section.id}`"
        :class="{
          'scene-clicky-thingy': true,
          'scene-clicky-thingy--active': isSectionActive(section),
          'scene-clicky-thingy--no-label': isLabelPresent(section),
        }"
        v-for="section in localSections"
        :key="section.id"
        :style="{ ...calculatePosition(section) }"
        @click="handleSectionClick(section)"
      ></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
import moment from "moment";
export default {
  name: "simple-scrubber",
  props: [
    "videoRef",
    "currentTime",
    "scrubberTimeChange",
    "sections",
    "data",
    "sections",
    "activeSectionId",
  ],
  data() {
    return {
      isMouseDown: false,
      scrubberPos: "0%",
      currentFormattedTime: this.convertToMmSs(this.currentTime),
      width: this.videoRef.clientWidth,
      duration: "",
      localActiveSectionId: null,
      localSections: [],
      localVideoRef: null,
    };
  },
  created() {
    if (this.currentTime !== 0) {
      this.handleCurrentTimeChange(this.currentTime);
    }
    this.videoRef.addEventListener("loadedmetadata", (e) => {
      this.duration = moment(0)
        .add(this.videoRef.duration, "seconds")
        .format("mm:ss");
    });
  },
  methods: {
    convertToMmSs(newVal) {
      const s = parseInt(newVal % 60);
      const m = parseInt((newVal / 60) % 60);
      const time = moment().seconds(s).minutes(m).format("mm:ss");
      return time;
    },
    handleBounds(time) {
      if (time > 100) {
        return 100;
      } else if (time < 0) {
        return 0;
      } else {
        return time;
      }
    },
    mouseDown(event) {
      // enable scrubbing
      this.isMouseDown = true;
      document.body.style.cursor = "grabbing";
      // remember the initial mouse position when the scubbing started

      document.addEventListener("mousemove", this.handleMouseMove);
      document.addEventListener("mouseup", this.handleMouseUp);
    },
    handleMouseMove(event) {
      if (this.isMouseDown) {
        var newPercentage = (event.clientX - 314) / this.width;
        this.scrubberPos = this.handleBounds(newPercentage * 100) + "%";
        this.scrubberTimeChange(newPercentage);
      }
    },
    handleMouseUp: function (event) {
      this.handleMouseMove(event);
      this.isMouseDown = false;
      document.body.style.cursor = "default";
      this.$emit("scrubberMouseUp");
    },
    handleCurrentTimeChange(newVal) {
      this.scrubberPos =
        this.handleBounds(newVal / this.videoRef.duration) * 100 + "%";
      const s = parseInt(newVal % 60);
      const m = parseInt((newVal / 60) % 60);
      this.currentFormattedTime = this.convertToMmSs(newVal);
    },
    calculatePosition(scene) {
      const left = this.handleBounds(
        (scene.timestamp_start - this.data.started_at) /
          1000 /
          this.localVideoRef.duration
      );
      let width =
        this.handleBounds(
          (scene.timestamp_end - this.data.started_at) /
            1000 /
            this.localVideoRef.duration
        ) - left;
      // This is to fix the issue with very-very short sections not showing up on the graph
      if (width < 0.01) width = 0.01;
      return {
        left: `${left * 100}%`,
        width: `${width * 100}%`,
      };
    },
    handleSectionClick(section) {
      this.$emit("currentSectionChange", section);
    },
    isSectionActive(section) {
      if (this.localActiveSectionId === null) return;
      return section.id === this.localActiveSectionId;
    },
    isLabelPresent(section) {
      return !section.label_id;
    },
    checkVideoRef() {
      // weird fix to check if the video is ready and then calculate sections
      if (this.videoRef.readyState === 4) {
        this.localActiveSectionId = this.activeSectionId;
        this.localSections = this.sections;
        this.localVideoRef = this.videoRef;
      } else {
        setTimeout(this.checkVideoRef, 100);
      }
    },
  },
  watch: {
    currentTime(newVal) {
      this.handleCurrentTimeChange(newVal);
    },
    duration(videoRef) {},
    sections(newVal) {
      this.localSections = newVal;
    },
    activeSectionId(newVal) {
      this.localActiveSectionId = newVal;
    },
  },
  mounted() {
    this.checkVideoRef();
  },
};
</script>
